/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Avatar_HintInputs */

const en_settings_profile_avatar_hint = /** @type {(inputs: Settings_Profile_Avatar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop an image, click to upload, or paste from clipboard`)
};

const zh_settings_profile_avatar_hint = /** @type {(inputs: Settings_Profile_Avatar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖拽图片、点击上传，或从剪贴板粘贴`)
};

/**
* | output |
* | --- |
* | "Drop an image, click to upload, or paste from clipboard" |
*
* @param {Settings_Profile_Avatar_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_avatar_hint = /** @type {((inputs?: Settings_Profile_Avatar_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Avatar_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_avatar_hint(inputs)
	return zh_settings_profile_avatar_hint(inputs)
});
export { settings_profile_avatar_hint as "settings.profile.avatar_hint" }